import React from "react";
import { Link } from "react-router-dom";
import {useWindowSize} from "../../hooks"; 
import { useTranslation } from 'react-i18next'

const subpageHeader = ({ setOpenSearch, openSearch }) => {
  const { t } = useTranslation(['data'])

  const size = useWindowSize();
  return (
    <div className="subpage-header">
      <div className="logo">
        <Link to="/"><img src="/media/es/images/small_logo_ferrrero"/></Link>
      </div>
      <div className="title">{t('catalogoDeProductos')}</div>
      {/* <div className="lang-container">
        <div className="lang-es"><span>ESP</span></div>
        <div className="lang-por"><span>POR</span></div>
      </div> */}
      {size.width > 428 ? (
        <div className="search">
          <div className="icon" onClick={() => setOpenSearch(!openSearch)} />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default subpageHeader;
